import { render, staticRenderFns } from "./company.component.html?vue&type=template&id=bd119040&scoped=true&external"
import script from "./company.component.ts?vue&type=script&lang=ts&external"
export * from "./company.component.ts?vue&type=script&lang=ts&external"
import style0 from "./company.component.scss?vue&type=style&index=0&id=bd119040&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd119040",
  null
  
)

export default component.exports